import { Badge } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { optionById } from '../fieldTypeMeta';
import { EmptyValue } from './EmptyValue';
import { TagDot } from './TagDot';

/**
 * The stored value is the option ID; the label and the colour are metadata
 * (docs/decisions/field-types.md, decision 1). An id with no matching option is
 * shown raw rather than hidden - that is a metadata bug the user should see, not
 * a blank cell.
 *
 * ON A READ SURFACE IT IS TEXT WITH A DOT, NOT A CAPSULE (`FieldContext.tagAsDot`, owner
 * 2026-09-10; P4 F1 and P5 F1, one rule since P5 round 3). The dot is only there when the
 * option carries a colour: an option with none has nothing to say in a dot, and an
 * invented grey circle would be a second encoding of nothing.
 */
export function SelectDisplay() {
  const { field, value, tagAsDot } = useFieldContext();
  if (typeof value !== 'string' || value.length === 0) {
    return <EmptyValue />;
  }
  const option = optionById(field, value);
  const label = option?.label ?? value;

  if (tagAsDot === true) {
    return (
      <span className="list-value">
        {option?.color !== undefined && <TagDot tone={option.color} />}
        <span className={option === undefined ? 'truncate font-mono' : 'truncate'}>{label}</span>
      </span>
    );
  }

  return (
    <Badge tone={option?.color ?? 'neutral'} className={option === undefined ? 'font-mono' : ''}>
      {label}
    </Badge>
  );
}
